var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",class:_vm.spacing ? `my-${_vm.spacing}` : ''},[_c('i',{staticClass:"fa",class:_vm.classes,attrs:{"aria-hidden":true}}),_c('div',{staticClass:"flex-grow-1 pl-1"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }